import { useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import RoundedButton from "../RoundedButton/RoundedButton.tsx";
import { LOG_OUT, NO_ACCESS_HEADING, NO_ACCESS_MESSAGE } from "../../constants/messages.tsx";
import { useLogoutMutation } from "../../api/auth.api.ts";

function InactiveUser() {
    const theme = useTheme();
    const [logout] = useLogoutMutation();

    const handleLogout = async () => {
        try {
            await logout().unwrap();
            await new Promise(resolve => setTimeout(resolve, 500));
            window.location.href = '/'; // Or redirect to login if needed
        } catch (e) {
            // Optionally show error
            await new Promise(resolve => setTimeout(resolve, 500));
            window.location.href = '/';
        }
    };
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: theme.palette.primary.main,
                color: 'white',
                textAlign: 'center',
                px: 2,
            }}
        >
            <Typography sx={{ color: 'white', pb: 3 }} variant="h3">{NO_ACCESS_HEADING}</Typography>
            <Typography sx={{ pb: 2, color: 'white' }}>{NO_ACCESS_MESSAGE}</Typography>
            <RoundedButton variantStyle="dark"
                variant="contained"
                data-testid="continue-to-asset-list-button"
                onClick={handleLogout}
                sx={{
                    bgcolor: theme.palette.secondary.main,
                }}
            >{LOG_OUT}</RoundedButton>

        </Box>
    );
}

export default InactiveUser;

